module.exports = __webpack_public_path__ + "img/کارت-ویزیت-پی-وی-سی-760-میکرون-متالیک.e9aebc6e.png";